export function initStickyHeader() {
	const header = document.querySelector("header");
	const sentinel = document.getElementById("ilawyer-header-trigger");
	if (!header || !sentinel) return;

	const io = new IntersectionObserver(
		([e]) => {
			if (!e.isIntersecting) {
				header.classList.add("scrolled");
			} else {
				header.classList.remove("scrolled");
			}
		},
		{
			root: null,
			threshold: 0,
			rootMargin: "-3px 0px 0px 0px",
		}
	);

	io.observe(sentinel);
}
